import React, { createContext, useContext } from "react";

const AuthModalContext = createContext(null);

export function AuthModalProvider({ children, value }) {
  return (
    <AuthModalContext.Provider value={value}>
      {children}
    </AuthModalContext.Provider>
  );
}

export function useAuthModal() {
  const context = useContext(AuthModalContext);
  if (!context) {
    throw new Error("useAuthModal must be used within an AuthModalProvider");
  }
  return context;
}

export default AuthModalContext;
